import { WrapperActivator } from './WrapperActivator';
import { SelectDate } from '../../SelectDate';

interface PopoverSelectDateProps {
  disabled?: boolean;
}
export const PopoverSelectDate: React.FC<PopoverSelectDateProps> = ({ disabled }) => {
  return (
    <SelectDate
      activator={({ onClick, value }) => {
        return <WrapperActivator label={value || ''} onClick={onClick} disabled={disabled} />;
      }}
    />
  );
};
